<template>
  <BaseModal
    name="orderSendModal"
    width="420"
    height="auto"
    @before-close="clearFields"
    @before-open="beforeOpen"
    :clickToClose="false"
    :shiftY="0.5"
    :adaptive="true"
    classes="!tw-bg-transparent !tw-shadow-none"
  >
    <div
      class="tw-bg-white tw-rounded-[25px] tw-py-[38px] tw-px-[30px] tw-relative tw-text-forTitle"
    >
      <button
        type="button"
        class="btn-close tw-absolute tw-right-[30px] tw-top-[20px] !tw-shadow-none"
        @click="$modal.hide('orderSendModal')"
      ></button>

      <BaseLoader v-if="localLoadingOrder" class="tw-rounded-[25px]"></BaseLoader>

      <div>
        <div class="tw-text-[23px] tw-mb-[15px] tw-text-center">
          Оформление заказа
        </div>

        <div class="tw-mb-[15px]">
          <div class="multiselect-type-3-label">Город</div>
          <BaseSelect
            class="multiselect-type-3"
            :customLabel="
              ({ cities__name }) => {
                return cities__name;
              }
            "
            :maxHeight="130"
            deselectLabel=""
            noOptions=""
            noResult=""
            selectedLabel=""
            placeholder="Не выбрано"
            selectLabel=""
            v-model="currentCity"
            :options="this.citiesList"
          >
          </BaseSelect>
        </div>

        <div class="multiselect-type-3-label !tw-my-[25px]">
          Товар / услуга: {{ currentProductName || "-" }}
        </div>

        <div class="tw-mb-[15px]">
          <div class="multiselect-type-3-label">
            Для какого объекта (по желанию)
          </div>
          <BaseSelect
            class="multiselect-type-3"
            style="width: 100%"
            :customLabel="
              ({ vehicles__name, vehicles__gosnumber, vehicles__id }) => {
                return vehicles__id
                  ? `${vehicles__name} ${vehicles__gosnumber}`
                  : vehicles__name;
              }
            "
            :maxHeight="130"
            deselectLabel=""
            noOptions=""
            noResult=""
            selectedLabel=""
            placeholder="Не выбрано"
            selectLabel=""
            v-model="objectSelected"
            :options="objectList"
          >
          </BaseSelect>
        </div>

        <div class="tw-mb-[15px]">
          <div class="multiselect-type-3-label">
            Собственник <br />
            (при оформлении полиса для страховой)
          </div>
          <BaseSelect
            class="multiselect-type-3"
            style="width: 100%"
            label="label"
            :maxHeight="130"
            deselectLabel=""
            noOptions=""
            noResult=""
            selectedLabel=""
            placeholder="Не выбрано"
            selectLabel=""
            v-model="ownerSelected"
            :options="ownerList"
          >
          </BaseSelect>
        </div>

        <div class="tw-mb-[15px]">
          <div class="multiselect-type-3-label">
            Страхователь <br />
            (при оформлении полиса для страховой)
          </div>
          <BaseSelect
            class="multiselect-type-3"
            style="width: 100%"
            label="label"
            :maxHeight="130"
            deselectLabel=""
            noOptions=""
            noResult=""
            selectedLabel=""
            placeholder="Не выбрано"
            selectLabel=""
            v-model="strahSelected"
            :options="ownerList"
          >
          </BaseSelect>
        </div>

        <div class="tw-mb-[15px]">
          <div class="multiselect-type-3-label">
            Больше деталей заказа (по желанию)
          </div>
          <BaseTextarea
            placeholder=""
            input-name="text"
            @onInput="(e) => (moreDetailString = e.value)"
            :minHeight="'120'"
            inputClass="tw-app-input-type-3"
            name-sign=""
            :value="moreDetailString"
          >
          </BaseTextarea>
        </div>

        <div class="tw-flex tw-gap-[10px] tw-mt-[15px] tw-justify-center">
          <button
            @click="$modal.hide('orderSendModal')"
            class="tw-app-btn-muted tw-app-btn-muted-lg"
          >
            Отменить
          </button>
          <button
            @click="onSaveOrder"
            class="tw-app-btn-primary tw-app-btn-primary-lg"
          >
            Заказать
          </button>
        </div>
      </div>
    </div>
  </BaseModal>
</template>

<script>
import GeneralService from "@/api/GeneralService";
import AboutUser from "@/api/AboutUser";

export default {
  data() {
    return {
      localLoadingOrder: false,
      currentProductId: null,
      currentProductName: "",
      citiesList: [],
      currentCity: null,
      objectList: [],
      objectSelected: null,
      ownerList: [],
      ownerSelected: null,
      strahSelected: null,
      moreDetailString: "",
      openParams: {},
    };
  },
  watch: {
    objectSelected(newVal, oldVal) {
      if (!newVal?.vehicles__id) return;
      this.setCityByObject();
    },
  },
  methods: {
    clearFields() {
      this.objectSelected = this.objectList[0] || null;
      this.ownerSelected = this.ownerList[0] || null;
      this.strahSelected = this.ownerList[0] || null;
      this.moreDetailString = "";
    },

    async beforeOpen(event) {
      this.localLoadingOrder = true;
      this.openParams = event?.params || {};
      this.currentProductId =
        Number(
          this.openParams.productId ||
            this.openParams?.product?.b2b_products__id ||
            0
        ) || null;
      this.currentProductName =
        this.openParams.productName ||
        this.openParams?.product?.b2b_products_description__name ||
        "";

      try {
        await this.loadReferenceData();

        if (!this.currentProductName && this.currentProductId) {
          await this.loadProductNameById(this.currentProductId);
        }

        this.setCurrentCity();
        this.setDefaults();
        if (this.objectSelected?.vehicles__id) this.setCityByObject();
      } catch (e) {
        this.$toast.error(
          e?.response?.data?.message || "Ошибка при загрузке формы заказа",
          { duration: 5000 }
        );
      } finally {
        this.localLoadingOrder = false;
      }
    },

    async loadReferenceData() {
      const requests = [];

      if (!this.ownerList.length) {
        requests.push(
          GeneralService.get("/object-owners/select/list", {
            params: { limit: 3000 },
          }).then((data) => {
            this.ownerList = data.data.data.map((x) => {
              return {
                label: Object.values(x)[0],
                value: Object.keys(x)[0],
              };
            });

            this.ownerList.unshift({
              label: "Не выбрано",
              value: null,
            });
          })
        );
      }

      // Always reload objects list on modal open to include newly duplicated vehicles.
      requests.push(
        GeneralService.get("/objects", { params: { limit: 10000 } }).then(
          (data) => {
            this.objectList = data.data.data.rows;
            this.objectList.unshift({
              vehicles__name: "Не выбрано",
              vehicles__id: null,
              vehicles__gosnumber: null,
            });
          }
        )
      );

      requests.push(
        GeneralService.get("/cities", { params: { limit: 10000 } }).then(
          (data) => {
            this.citiesList = data.data.data.rows;
          }
        )
      );

      requests.push(
        AboutUser.getAllAboutUser().then((data) => {
          this.openParams.companyDefaultCityId =
            data.data.data.company_default_city_id;
        })
      );

      await Promise.all(requests);
    },

    async loadProductNameById(productId) {
      return GeneralService.get("/products", {
        params: {
          limit: 1,
          where: JSON.stringify([
            { field: "b2b_products__id", value: productId },
          ]),
        },
      }).then((data) => {
        const product = data?.data?.data?.rows?.[0];
        if (product) {
          this.currentProductName = product.b2b_products_description__name;
        }
      });
    },

    setCurrentCity() {
      const cityId = Number(
        this.openParams.cityId || this.openParams.companyDefaultCityId
      );
      this.currentCity =
        this.citiesList.find((city) => Number(city.cities__id) === cityId) ||
        this.citiesList[0] ||
        null;
    },
    setCityByObject() {
      GeneralService.get(
        `/places/${this.objectSelected.vehicles__place_id}?fields=vehicle_places__id,cities__id,cities__name`
      )
        .then((res) => {
          let id = res.data?.rows?.[0]?.cities__id;
          if (id)
            this.currentCity = this.citiesList.find((c) => c.cities__id === id);
        })
        .catch((e) => {
          console.log(e);
        });
    },
    setDefaults() {
      const objectId = Number(this.openParams.objectId);
      const ownerIdFromParams =
        this.openParams.ownerId !== undefined
          ? Number(this.openParams.ownerId)
          : null;
      const shouldAutofillOwner = this.shouldAutofillOwnerByProductId(
        this.openParams.productId
      );

      this.objectSelected =
        this.objectList.find(
          (item) => Number(item.vehicles__id) === objectId
        ) ||
        this.objectList[0] ||
        null;

      const ownerIdFromObject = shouldAutofillOwner
        ? this.extractOwnerIdFromObject(this.objectSelected)
        : null;
      const ownerId = shouldAutofillOwner
        ? ownerIdFromParams || ownerIdFromObject
        : null;

      if (ownerId) {
        this.ownerSelected =
          this.ownerList.find((item) => Number(item.value) === ownerId) ||
          this.ownerList[0] ||
          null;
        // Do NOT auto-assign insurer/policyholder (`strahSelected`) — user must select it manually
        this.strahSelected = this.ownerList[0] || null;
      } else {
        this.ownerSelected = this.ownerList[0] || null;
        this.strahSelected = this.ownerList[0] || null;
      }
    },

    shouldAutofillOwnerByProductId(productId) {
      const normalizedProductId = Number(productId);
      return [13, 14].includes(normalizedProductId);
    },

    extractOwnerIdFromObject(objectItem) {
      if (!objectItem) {
        return null;
      }

      const rawOwnerId =
        objectItem.vehicles__owner_id ??
        objectItem.objects__owner_id ??
        objectItem.vehicle_owners__id ??
        null;

      const ownerId = Number(rawOwnerId);
      return Number.isNaN(ownerId) ? null : ownerId;
    },

    normalizeId(value) {
      if (value === null || value === undefined || value === "") {
        return null;
      }

      const numeric = Number(value);
      return Number.isNaN(numeric) ? null : numeric;
    },

    onSaveOrder() {
      if (!this.currentProductId) {
        this.$toast.error("Не определен продукт для заказа", {
          duration: 5000,
        });
        return;
      }

      if (!this.currentCity?.cities__id) {
        this.$toast.error("Не определен город для заказа", { duration: 5000 });
        return;
      }

      this.localLoadingOrder = true;
      GeneralService.editOrCreate("/b2b-orders/type1", {
        b2b_orders__b2b_product_id: this.currentProductId,
        b2b_orders__city_id: this.currentCity.cities__id,
        object_id: this.normalizeId(this.objectSelected?.vehicles__id),
        owner_id: this.normalizeId(this.ownerSelected?.value),
        policyholder_id: this.normalizeId(this.strahSelected?.value),
        b2b_orders__buyer_comment: this.moreDetailString,
      })
        .then((data) => {
          this.$toast.success(data.data?.message || "Заказ отправлен");
          this.$modal.hide("orderSendModal");
        })
        .catch((e) => {
          this.$toast.error(
            e?.response?.data?.message || "Ошибка при отправке заказа",
            { duration: 5000 }
          );
        })
        .finally(() => {
          this.clearFields();
          this.localLoadingOrder = false;
        });
    },
  },
};
</script>
